/**
 * T076 — React 19 root mount. The styles are imported in dependency order:
 * tokens (via base.css) first, then page-level sheets.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./styles/base.css";
import "./styles/dashboard.css";
import "./styles/components.css";
import "./styles/proposal-detail.css";
import "./styles/about.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("Missing #root — check frontend/index.html");
}
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
